import * as React from 'react';
import * as d3 from 'd3';

import { Grid, Header, Dropdown } from 'semantic-ui-react';
import { store } from '../stores/Store';

import { utils } from '../stores/Utils';


export class CtrlPanel extends React.Component {
    private node: {entity: any, others: any};
    private svg: {entity: any, others: any};
    private margin: {top: number, right: number; bottom: number; left: number; };

    constructor(props: any, context: any) {
        super(props, context);
        this.node = {entity: null, others: null};
        this.svg = {entity: null, others: null};
        this.margin = { top: 10, right: 20, bottom: 20, left: 20 };
    }
    private renderSampleDropdown(): JSX.Element {
        return <Dropdown placeholder={'10 worst predicted samples'}
            search selection
            onChange={(e, value) => {
                store.sampleMethod = value.value as string;
                store.questions = store.sampleQuestions(store.questionStore);
            }}
            options={[
                {text: '10 worst predicted samples', value: 'worst', key: 'worst'},
                {text: '10 best predicted samples', value: 'best', key: 'best'},
                {text: '10 random samples', value: 'rand', key: 'rand'},
            ]}>
        </Dropdown>
    }


    private renderLegendSVG(key: string): JSX.Element {
        return <svg ref={node => this.node[key] = node} className='full-width' height={50}>
        </svg>
    }

    private renderAttentionColors(key: string): void {
        const container = document.getElementById(`attentionType-${key}`);
        const containerWidth = container === null ? 150 : container.clientWidth;
        const size = (containerWidth - this.margin.left - this.margin.right) / utils.attentionColor[key].length > 24 ? 
            24 : (containerWidth - this.margin.left - this.margin.right) / utils.attentionColor[key].length;
        const panel = this.svg[key].append('g')
            .attr('transform', `translate(${this.margin.left}, ${this.margin.top})`);
        panel.selectAll('.attentionLegend')
            .data(utils.attentionColor[key]).enter().append('rect')
            .attr('x', (d: string, idx: number) =>  idx * size)
            .attr('y', 0)
            .attr('width', size / 1.2)
            .attr('height', size / 1.2)
            .attr('fill', (d: string) => d);
        panel.append('text')
            .attr('x', 0)
            .attr('y', 0)
            .attr('dx', '-1em')
            .attr('dy', '1em')
            .attr('text-align', 'right')
            .text('0');
        
        panel.append("text")
            .attr('x', utils.attentionColor[key].length * size)
            .attr('y', 0)
            .attr('dx', '1em')
            .attr('dy', '1em')
            .text('1');
    }

    public componentDidMount() {
        this.svg.entity = d3.select(this.node.entity);
        this.svg.others = d3.select(this.node.others);
        this.renderAttentionColors('entity');
        this.renderAttentionColors('others')
     }

    public render() {
        return (
            <Grid className='full-width'>
            <Grid.Column width={16}>
                <Header as='h5'>Sampling</Header>
                {this.renderSampleDropdown()}
            </Grid.Column>
            <Grid.Column width={16}>
                <Header as='h5'>Answer Legends</Header>
                {['groundtruth', 'correct', 'incorrect'].map(d =>
                     <Grid.Row key={`answerType-${d}`} style={{marginBottom: 10}}><span className='token answer'
                     style={{color: utils.answerColor[d].dark}}>{`
                     ${d==='groundtruth' ? '' : 'predicted'} ${d} answer`}</span></Grid.Row>
                )}
            </Grid.Column>
            <Grid.Column width={16}>
                <Header as='h5'>Token backgrounds</Header>
                {['others'].map(key =>
                     <Grid.Row key={`attentionType-${key}`}>
                     <span className='token'
                        style={{backgroundColor: utils.attentionColor[key][utils.attentionColor[key].length > 1 ? 2 : 0]}}>
                        {key === 'entity' ? 'Entities' : 'Attention matches'}
                     </span>
                    <div className='full-width' id={`attentionType-${key}`}>{key === 'others' ? this.renderLegendSVG(key) : ''}</div>
                     </Grid.Row>
                )}
            </Grid.Column>
        </Grid>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/CtrlPanel.tsx